import { ldcDetail } from '../../optDetail';
export class Customer {
    accountId: string;
    name: string;
    zipcode: string;
    phase: string;
    effectiveDate: Date;
    isVerified: boolean;
    isOptOutRestricted: boolean;
    isMultiAccount: boolean;
    isProgramOptionsAvailable: boolean | null;
    isRestricted: boolean;
    ldcAccounts: ldcDetail[];
}

export class CustomerInfo {
    cca: string;
    action: string;
    contactIds: string[];
}

export class Restrictions {
    restrictionType: string;
    isRestricted: boolean;
}

export enum RestrictionTypes {
    restriction = 'restriction',
    prompt = 'prompt'
}